import fetchData from "../utils/HttpClient";
import {CustomerInterface} from "../interfaces/customer/CustomerInterface";

export function alfaRedirectLink(): Promise<{ uri: string }> {
    return fetchData('/api/open-id/alfa-redirect-link')
}

export function alfaUserInfo(code: string): Promise<CustomerInterface> {
    return fetchData('/api/open-id/alfa/' + code)
}